if (!customElements.get('ck-vehicle-addons')) {
  customElements.define('ck-vehicle-addons', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        if (this.requiresOffer) this.watchExistingOffer();
        return;
      }
      this.products = JSON.parse(this.querySelector('[data-helmet-products]').textContent);
      this.color = this.querySelector('[data-helmet-color]');
      this.size = this.querySelector('[data-helmet-size]');
      this.toggle = this.querySelector('[data-helmet-toggle]');
      this.cover = this.querySelector('[data-cover-toggle]');
      this.requiresOffer = this.hasAttribute('data-existing-offer');
      this.sourceCards = new Set();
      if (!this.products.length) this.querySelector('[data-helmet-card]').hidden = true;
      this.products.forEach(product => {
        const option = new Option(product.color, String(product.id));
        if (!product.variants.some(variant => variant.available)) option.textContent += ' · ' + this.dataset.unavailable;
        this.color.add(option);
      });
      const initial = this.products.find(product => product.variants.some(variant => variant.available));
      if (initial) this.color.value = String(initial.id);
      this.color.addEventListener('change', () => this.updateColor());
      this.size.addEventListener('change', () => this.updateVariant());
      this.updateColor();
      this.initialized = true;
      if (this.requiresOffer) this.watchExistingOffer();
      else this.hidden = false;
    }
    disconnectedCallback() {
      this.offerObserver?.disconnect();
      cancelAnimationFrame(this.offerFrame);
      this.sourceCards?.forEach(card => card.removeAttribute('data-ck-helmet-replaced'));
      this.sourceCards?.clear();
    }
    watchExistingOffer() {
      this.offerScope = this.closest('.product__info-container');
      if (!this.offerScope) return;
      this.offerObserver?.disconnect();
      this.offerObserver = new MutationObserver(() => {
        cancelAnimationFrame(this.offerFrame);
        this.offerFrame = requestAnimationFrame(() => this.syncExistingOffer());
      });
      this.offerObserver.observe(this.offerScope, {childList: true, subtree: true, attributes: true, attributeFilter: ['lb-product-id', 'lb-variant-id', 'lb-default-price', 'offer', 'style', 'hidden']});
      this.syncExistingOffer();
    }
    syncExistingOffer() {
      const matches = [];
      this.offerScope?.querySelectorAll('lb-upsell-widget[widget="widget#pal"][offer]').forEach(widget => {
        if (widget.getAttribute('lb-trigger-product-id') !== this.dataset.productId || widget.hidden || getComputedStyle(widget).display === 'none') return;
        widget.querySelectorAll('lb-upsell-flat-card[lb-product-id]').forEach(card => {
          const product = this.products.find(item => String(item.id) === card.getAttribute('lb-product-id'));
          const variant = product?.variants.find(item => String(item.id) === card.getAttribute('lb-variant-id'));
          const checkbox = card.querySelector('input.lb-card-checkbox');
          const price = card.querySelector('.lb-price-sale-price[lb-default-price]');
          if (!variant || !checkbox || !price || Number(price.getAttribute('lb-default-price')) !== variant.amount) return;
          matches.push({card, product, variant, checkbox, offer: widget.getAttribute('offer')});
        });
      });
      const offerIdentity = Array.from(new Set(matches.map(match => match.offer))).sort().join('|');
      const current = new Set(matches.map(match => match.card));
      this.sourceCards.forEach(card => {
        if (!current.has(card)) {
          card.removeAttribute('data-ck-helmet-replaced');
          this.sourceCards.delete(card);
        }
      });
      let blocked = false;
      matches.forEach(({checkbox}) => {
        if (checkbox.checked) {
          this.pendingNativeSelection = true;
          checkbox.click();
        }
        if (checkbox.checked) blocked = true;
      });
      if (blocked) {
        this.sourceCards.forEach(card => card.removeAttribute('data-ck-helmet-replaced'));
        this.sourceCards.clear();
        if (!this.hidden) this.hidden = true;
        this.toggle.checked = false;
        return;
      }
      let eligible = false;
      matches.forEach(({card, product, variant}) => {
        if (!this.sourceCards.has(card)) {
          if (!this.sourceCards.size && this.seededOfferIdentity !== offerIdentity) {
            this.color.value = String(product.id);
            this.updateColor();
            this.size.value = String(variant.id);
            this.updateVariant();
            this.seededOfferIdentity = offerIdentity;
          }
          this.sourceCards.add(card);
          card.setAttribute('data-ck-helmet-replaced', '');
        }
        eligible = true;
      });
      if (eligible && this.pendingNativeSelection) this.toggle.checked = !this.toggle.disabled;
      this.pendingNativeSelection = false;
      if (this.hidden === eligible) this.hidden = !eligible;
      if (!eligible) this.toggle.checked = false;
    }
    sizeKey(value) {
      return String(value || '').trim().split(/[\s(]/)[0].toUpperCase();
    }
    updateColor() {
      const previousSize = this.selectedVariant ? this.sizeKey(this.selectedVariant.size) : '';
      this.selectedProduct = this.products.find(product => String(product.id) === this.color.value);
      if (!this.selectedProduct) return;
      this.size.replaceChildren();
      this.selectedProduct.variants.forEach(variant => {
        const label = variant.size.replace(/(\d)\)/, '$1cm)');
        const option = new Option(label + (variant.available ? '' : ' · ' + this.dataset.unavailable), String(variant.id));
        option.disabled = !variant.available;
        this.size.add(option);
      });
      const nextVariant = this.selectedProduct.variants.find(variant => this.sizeKey(variant.size) === previousSize) || this.selectedProduct.variants.find(variant => variant.available) || this.selectedProduct.variants[0];
      if (nextVariant) this.size.value = String(nextVariant.id);
      this.querySelector('[data-helmet-image]').src = this.selectedProduct.image;
      this.querySelectorAll('[data-helmet-link]').forEach(link => link.href = this.selectedProduct.url);
      this.updateVariant();
    }
    updateVariant() {
      this.selectedVariant = this.selectedProduct?.variants.find(variant => String(variant.id) === this.size.value);
      if (!this.selectedVariant) return;
      this.querySelector('[data-helmet-price]').textContent = this.selectedVariant.price;
      const compare = this.querySelector('[data-helmet-compare]');
      compare.textContent = this.selectedVariant.compare || '';
      compare.hidden = !this.selectedVariant.compare;
      this.toggle.disabled = !this.selectedVariant.available;
      if (this.toggle.disabled) this.toggle.checked = false;
      this.querySelector('[data-helmet-status]').textContent = this.toggle.disabled ? this.dataset.chooseSize : '';
      this.querySelectorAll('[data-helmet-link]').forEach(link => link.href = this.selectedProduct.url + '?variant=' + this.selectedVariant.id);
    }
    appendItems(formData) {
      if (this.requiresOffer) {
        this.syncExistingOffer();
        if (this.hidden) return false;
      }
      const items = [];
      if (this.toggle.checked && !this.toggle.disabled && this.selectedVariant?.available) items.push(this.selectedVariant.id);
      if (this.cover?.checked && !this.cover.disabled) items.push(this.cover.dataset.variantId);
      if (!items.length || !formData.get('id') || formData.has('items[0][id]')) return false;
      for (const [key, value] of Array.from(formData.entries())) {
        if (['id', 'quantity', 'selling_plan'].includes(key)) {
          formData.delete(key);
          formData.append('items[0][' + key + ']', value);
        } else if (key.startsWith('properties[')) {
          formData.delete(key);
          formData.append('items[0][properties]' + key.slice('properties'.length), value);
        }
      }
      if (!formData.has('items[0][quantity]')) formData.set('items[0][quantity]', '1');
      items.forEach((id, index) => {
        formData.set('items[' + (index + 1) + '][id]', String(id));
        formData.set('items[' + (index + 1) + '][quantity]', '1');
      });
      return true;
    }
  });
}
